import { useContext, useEffect, useState } from "react";
import { config } from "../../../../constant";
import { useElement, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useGenericChatBot = () => {
  const Actor = useElement("Actor");
  const { commonPageSize } = config;
  const { fetchAll, remove, save, update } = useService("Data", "chat");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { showAlert, generateUID, closeModal, openModal, isBottom } =
    useService("Misc");
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [chatList, setchatList] = useState([]);
  const [activeItem, setactiveItem] = useState(null);
  const [question, setquestion] = useState<string>("");
  const [answer, setanswer] = useState<string>("");
  const [uid, setuid] = useState<string>("");
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [showTrashConfirm, setshowTrashConfirm] = useState<boolean>(false);
  const [filteredList] = useState([]);
  const [tableContent, settableContent] = useState(null);

  setTitle("Generic Chat", "admin");
  useEffect(() => {
    getChatsData();
  }, []);

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  };

  const showMore = () => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  };

  const getChatsData = async () => {
    const result = await fetchAll();
    if (result.status) {
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: "No chats placed yet!" });
      } else {
        let chatList = [];
        result.data.forEach((e) => {
          if (e.type === "generic") chatList.push(e);
        });
        setchatList(chatList);
      }
    }
  };

  const trashCancel = () => {
    setactiveItem(null);
    setshowTrashConfirm(false);
  };

  const trashChat = async () => {
    const result = await remove({ uid: activeItem.uid });
    if (result.status) {
      getChatsData();
      showAlert({ type: "success", msg: "Chat deleted successfully!" });
      setactiveItem(null);
      setshowTrashConfirm(false);
    } else showAlert({ type: "error", msg: "Unable to delete chat!" });
  };

  const addChat = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      chatObject = {
        question,
        answer,
        type: "generic",
        uid: mode === "add" ? generateUID() : uid,
      };
    if (question === "" || answer === "") {
      errorMsg = "Please enter chat content!";
      error = true;
    }
    if (!error) {
      if (mode === "add") {
        const result = await save(chatObject);
        if (result.status) {
          showAlert({ type: "success", msg: "Chat added successfully!" });
        } else {
          showAlert({ type: "error", msg: "Unable to add chat!" });
        }
        setquestion("");
        setanswer("");
        setuid("");
        closeModal("chat-modal");
        getChatsData();
      } else {
        let data = {
          query: JSON.stringify({ uid }),
          chatData: JSON.stringify(chatObject),
        };
        const result = await update(data);
        if (result.status) {
          showAlert({ type: "success", msg: "Chat updated successfully!" });
        } else {
          showAlert({ type: "error", msg: "Unable to update chat!" });
        }
        setquestion("");
        setanswer("");
        setuid("");
        closeModal("chat-modal");
        getChatsData();
      }
    } else showAlert({ type: "error", msg: errorMsg });
  };

  const getTableData = (filterData) => {
    let data = [];
    filterData.forEach((item) => {
      let e = {
        data: (
          <>
            <p className="query">
              <b>Q: </b>
              {item.question}
            </p>
            <p className="ans">
              <b>A: </b>
              {item.answer}
            </p>
          </>
        ),
        action: (
          <div className="action-bar" style={{ bottom: 10 }}>
            <Actor
              type="edit"
              onClick={() => {
                setmode("edit");
                setquestion(item.question);
                setanswer(item.answer);
                setuid(item.uid);
                openModal("chat-modal");
              }}
            />
            <Actor
              type="trash"
              onClick={() => {
                setactiveItem(item);
                setshowTrashConfirm(true);
              }}
            />
          </div>
        ),
      };
      data.push(e);
    });
    return data;
  };

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: "Queries",
          key: "queries",
        },
        {
          label: "Action",
          key: "action",
        },
      ],
      content: getTableData(chatList),
    });
  }, [chatList]);
  return {
    trackScrolling,
    setmode,
    tableContent,
    trashChat,
    trashCancel,
    showTrashConfirm,
    setuid,
    mode,
    addChat,
    question,
    setquestion,
    answer,
    setanswer,
  };
};
